export default __webpack_public_path__ + "static/media/mongodb.21b2e078.svg";